<template>
  <div class="mhome">
    <swiper :options="swiperOption">
      <!-- <swiper-slide><img class="home-swiper-img" src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/m-home/banner1.png" alt=""></swiper-slide>
      <swiper-slide><img class="home-swiper-img" src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/m-home/banner2.png" alt=""></swiper-slide>
      <swiper-slide><img class="home-swiper-img" src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/m-home/banner3.png" alt=""></swiper-slide> -->
      <swiper-slide><div class="mhome-div1"></div></swiper-slide>
      <swiper-slide><div class="mhome-div2"></div></swiper-slide>
      <swiper-slide><div class="mhome-div3"></div></swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
    <div class="mhome-dynamic">
      <div class="mhome-dynamic-top">
        <div class="mhome-dynamic-h1">
          <div></div>
          <h1>公司动态</h1>
          <div></div>
        </div>
        <h2>DYNAMIC</h2>
      </div>
      <div class="mhome-dynamic-left">
        <img src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/images/xinwentu.png" alt />
        <div class="mhome-dynamic-position">
          <div class="mhome-dynamic-data">
            <h1 class="mhome-dynamic-title">{{notice.name}}</h1>
            <p class="mhome-dynamic-text">{{notice.brief}}</p>
          </div>
          <div class="mhome-dynamic-time">
            <h1>{{notice.tm.M + '-' + notice.tm.D}}</h1>
            <p>{{notice.tm.Y}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="mhome-notice">
      <div class="nmhome-otice-data">
        <div
          class="mhome-notice-data-box"
          v-for="(item,index) in noticelist"
          :key="index"
          v-show="(index >= idx * 3) && (index < idx * 3 + 3)"
          @click="toActive(item.id)"
        >
          <div class="mhome-notice-data-left">
            <h1>{{item.tm.M + '-' + item.tm.D}}</h1>
            <p>{{item.tm.Y}}</p>
          </div>
          <div class="mhome-notice-data-right">
            <h1>{{item.name}}</h1>
            <p>{{item.brief}}</p>
          </div>
        </div>
      </div>
      <div class="mhome-notice-bottom" v-if="noticelist.length > 3">
        <div></div>
        <ul>
          <li
            v-for="i in circleList"
            :key="i"
            @click="changeValue(i)"
            :class="idx == i - 1 ? 'mhome-notice-active' : ''"
          ></li>
        </ul>
        <div></div>
      </div>
    </div>
  </div>
</template>
<script>
let timer = null;
import { Article, timestampToTime } from "./../../services/article";
export default {
  components: {},
  data() {
    return {
      banIdx: 0,
      idx: 0,
      noticelist: [],
      notice: {
        tm: {
          Y: "",
          M: "",
          D: ""
        }
      },
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true // 允许点击小圆点跳转
        },
        autoplay: {
          delay: 3000,
          disableOnInteraction: false // 手动切换之后继续自动轮播
        },
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      }
    };
  },
  watch: {},
  destroyed() {
    clearInterval(timer);
  },
  mounted() {
    Article({
      category_id: 80
    }).then(res => {
      res.items.forEach((ele, i) => {
        let tm = timestampToTime(ele.release_time);
        ele.tm = tm;
        if (i == 0) {
          this.notice = ele;
        } else {
          this.noticelist.push(ele);
        }
      });
    });
  },
  methods: {
    bannertap(item) {
      this.banIdx = item;
    },
    changeValue(i) {
      this.idx = i - 1;
    },
    toActive(id) {
      this.$router.push({
        path: "/mactive",
        query: {
          id
        }
      });
    }
  },
  computed: {
    circleList: function() {
      let i = Math.ceil(this.noticelist.length / 3);
      return i;
    }
  }
};
</script>
<style>
.mhome-div1 {
    width: 100%;
    height: 8.64rem;
    background: url('http://bernouly.oss-cn-beijing.aliyuncs.com/images/m-home/banner1.png') center center no-repeat;
    background-size: 100% 100%;
}
.mhome-div2 {
    width: 100%;
    height: 8.64rem;
    background: url('http://bernouly.oss-cn-beijing.aliyuncs.com/images/m-home/banner2.png') center center no-repeat;
    background-size: 100% 100%;
}
.mhome-div3 {
    width: 100%;
    height: 8.64rem;
    background: url('http://bernouly.oss-cn-beijing.aliyuncs.com/images/m-home/banner3.png') center center no-repeat;
    background-size: 100% 100%;
}
.mhome {
  padding-bottom: 0.9rem;
}
.mhome-top {
  position: relative;
}
.mhome-top img {
  width: 100%;
}

.mhome-top ul {
  display: flex;
  position: absolute;
  bottom: 0.4rem;
  width: 0.72rem;
  left: 50%;
  margin-left: -0.36rem;
}
.mhome-top ul li {
  margin: 0 0.05rem;
  cursor: pointer;
}
.mhome-top .notive {
  width: 0.14rem;
  height: 0.14rem;
  border-radius: 50%;
  background: #dae6ff;
}
.mhome-top .active {
  width: 0.12rem;
  height: 0.12rem;
  border-radius: 50%;
  border: 0.01rem solid #dae6ff;
}

.mhome-dynamic-top {
  margin-top: 0.6rem;
}
.mhome-dynamic-top h1 {
  font-size: 0.3rem;
  color: #000;
  text-align: center;
}
.mhome-dynamic-top h2 {
  font-size: 0.14rem;
  color: #999;
  text-align: center;
  margin-top: 0.2rem;
}
.mhome-dynamic-h1 {
  display: flex;
  justify-content: center;
  align-items: center;
}
.mhome-dynamic-h1 h1 {
  margin: 0 0.2rem;
}
.mhome-dynamic-h1 div {
  width: 0.36rem;
  height: 0.02rem;
  background: #d4d4d4;
}
.mhome-dynamic-bottom {
  width: 100%;
}
.mhome-dynamic-left {
  margin: 0.4rem;
  position: relative;
}
.mhome-dynamic-left img {
  width: 100%;
}
.mhome-dynamic-position {
  cursor: pointer;
  width: 100%;
  height: 1rem;
  background: rgba(0, 0, 0, 0.4);
  position: absolute;
  left: 0;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  color: #fff;
}
.mhome-dynamic-data {
  width: 75%;
  margin-left: 0.2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.mhome-dynamic-data h1 {
  font-size: 0.26rem;
  margin-bottom: 0.15rem;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.mhome-dynamic-data p {
  font-size: 0.18rem;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.mhome-dynamic-time {
  width: 1rem;
  height: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #0a57f4;
}
.mhome-dynamic-time h1 {
  width: 0.7rem;
  text-align: center;
  font-size: 0.22rem;
  font-weight: bold;
  padding-bottom: 0.05rem;
  border-bottom: 0.01rem solid #fff;
  margin-bottom: 0.05rem;
}
.mhome-dynamic-time p {
  font-size: 0.18rem;
}

.mhome-notice-data-box {
  display: flex;
  margin: 0.4rem;
  cursor: pointer;
}
.mhome-notice-data-left {
  width: 1.4rem;
  height: 1.32rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #fff;
  border: 1px solid #b4b4b4;
  color: #666;
  margin-right: 0.3rem;
}
.mhome-notice-data-left h1 {
  width: 0.7rem;
  text-align: center;
  font-size: 0.22rem;
  font-weight: bold;
  padding-bottom: 0.05rem;
  border-bottom: 0.01rem solid #b4b4b4;
  margin-bottom: 0.05rem;
}
.mhome-notice-data-left p {
  font-size: 0.18rem;
}
.mhome-notice-data-right {
  width: 75%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  height: 1.2rem;
}
.mhome-notice-data-right h1 {
  color: #111;
  font-size: 0.26rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 0.15rem;
}
.mhome-notice-data-right p {
  color: #666;
  font-size: 0.24rem;
  margin-bottom: 0.1rem;
  line-height: 0.36rem;
}
.mhome-notice-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 0.4rem;
}
.mhome-notice-bottom div {
  width: 2.66rem;
  height: 0.01rem;
  background: #d4d4d4;
}
.mhome-notice-bottom ul {
  display: flex;
  margin: 0 0.3rem;
}
.mhome-notice-bottom ul li {
  width: 0.1rem;
  height: 0.1rem;
  background: #d4d4d4;
  border-radius: 50%;
  margin: 0 0.05rem;
  cursor: pointer;
}
.mhome-notice-bottom .mhome-notice-active {
  background: #0a57f4;
}

.swiper-pagination span {
  background: #fff;
}
</style>
